import { useState } from 'react';
import PropTypes from 'prop-types';
import CloseIcon from '../../../assets/icons/close.svg?react';

const AppendRoleSideModal = ({ 
  onClose, 
  onSave 
}) => {
  const [roleName, setRoleName] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleRoleAppend = async () => {
    if (!roleName.trim()) {
      alert('역할 이름을 입력해주세요.');
      return;
    }

    setIsSubmitting(true);
    try {
      await onSave(roleName.trim());
      setRoleName('');
      onClose();
    } catch (error) {
      console.error('역할 추가 실패:', error);
      alert('역할 추가에 실패했습니다.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="side-modal-background">
      <div className="side-modal-container">
        <div className="side-modal-header">
          <h3>역할 추가</h3>
          <div className="side-modal-close" onClick={onClose}>
            <CloseIcon />
          </div>
        </div>
        <div className="side-modal-content">
          <table className='transparent-table w-full'>
            <tr>  
              <td>
                <label htmlFor="roleName" className='w-20 mr-10 text-b2-700 required'>역할 이름</label>
              </td>
              <td>
                <input 
                  value={roleName} 
                  type="text" 
                  id="roleName" 
                  className='w-full input-primary' 
                  placeholder='역할 이름을 입력해주세요.' 
                  onChange={(e) => setRoleName(e.target.value)}
                  disabled={isSubmitting}
                  autoFocus
                />
              </td>
            </tr>
          </table>
          <div className='flex w-full mt-20'>
            <button 
              className='btn big-btn btn-primary flex-1' 
              onClick={handleRoleAppend}
              disabled={isSubmitting || !roleName.trim()}
            >
              {isSubmitting ? '추가 중...' : '추가'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

AppendRoleSideModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

export default AppendRoleSideModal;
